/**
 * Light / dark theme of the driver app (DRV-010). «Sistema» follows the phone (the tokens already
 * answer to prefers-color-scheme); «Claro» and «Oscuro» pin it with `data-theme` on <html>.
 * Kept per phone in localStorage: it is a preference of this device, not of the account.
 */
export type ThemeChoice = 'system' | 'light' | 'dark';

const KEY = 'driver.theme';

export function storedTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    // private mode or blocked storage: the phone's own mode
    return 'system';
  }
}

export function applyTheme(choice: ThemeChoice) {
  const root = document.documentElement;
  if (choice === 'system') delete root.dataset.theme;
  else root.dataset.theme = choice;
}

export function saveTheme(choice: ThemeChoice) {
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // not kept: it still applies until the app is closed
  }
  applyTheme(choice);
}
